import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { expireSession } from "./authSlice";
import { isPublicPath } from "../../utils/publicPaths";
import { Capacitor } from "@capacitor/core";

const host = window.location.hostname;
let BASE_URL;

if (Capacitor.isNativePlatform()) {
  BASE_URL = "https://api-hrms.firstpartnerconsulting.com";
} else if (host === "localhost") {
  BASE_URL = "http://localhost:8080";
} else if (host === "192.168.0.151") {
  BASE_URL = "http://192.168.0.151:8080";
} else if (host === "hrms.firstpartnerconsulting.com") {
  BASE_URL = "https://api-hrms.firstpartnerconsulting.com";
} else {
  BASE_URL = "https://api-hrms.firstpartnerconsulting.com";
}
const rawBaseQuery = fetchBaseQuery({
  baseUrl: BASE_URL,
  prepareHeaders: (headers, { getState, endpoint }) => {
    if (endpoint !== "login") {
      const token = getState()?.auth?.token;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
    }
    // headers.set("Content-Type", "application/json");
    return headers;
  },
});

// If the JWT has expired or is otherwise rejected by the backend, clear the
// session so the app shows the "session expired" modal and redirects to the
// login page (see AuthExpiryWatcher). Excluded:
// - the login endpoint - a failed login is a 401 with no session to clear.
// - any public route (login, register, activate-account, forgot/restore
//   password) - those pages work without a session, and a stale/expiring
//   token left over from an unrelated earlier session must never interrupt
//   someone activating an account or resetting a password.
const baseQueryWithAuthLogout = async (args, api, extraOptions) => {
  const result = await rawBaseQuery(args, api, extraOptions);
  if (
    result.error?.status === 401 &&
    api.endpoint !== "login" &&
    !isPublicPath(window.location.pathname)
  ) {
    api.dispatch(expireSession());
  }
  return result;
};

export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithAuthLogout,
  tagTypes: [
    "Leaves",
    "Claims",
    "Advance",
    "ClaimProof",
    "Settlement",
    "Users",
    "Products",
    "Attendance",
    "TodayAttendance",
    "Me",
    "CompOffs",
    "Holidays",
    "MasterData",
    "OnboardingRequests",
    "Client",
    "Potential",
    "CRM_DROPDOWN",
    "ADVANCES",
    "HR_ADVANCES",
    "SETTLEMENT_SUMMARY",
    "RECOVERY_HISTORY",
    "ADVANCE_LEDGER",
    "ALLOCATION_HISTORY",
    "Tasks",
    // Legacy client-scoped master data (/api/v1/tasks/master-data). Already
    // referenced by tasksApi.getTaskMasterData but was never declared here,
    // so RTK Query ignored it - declaring it makes that cache invalidate.
    "TaskMasterData",
    // Global Main Task / Sub Task catalogue (/api/v1/task-master).
    "TaskMaster",
  ],
  endpoints: () => ({}),
});

